import { TriangleAlertIcon } from 'lucide-react'
import { useEffect, useState } from 'react'

import { useAppBanners } from '@/lib/app/app-banners'
import { useRemoteConfigPayload } from '@/lib/config/remote-config'
import { cn } from '@/lib/ui/style-helpers'

import { BANNER_HEIGHT } from './consts'
import { APP_BANNERS_LABELS } from './labels'

const SupportBanner = () => {
  const [isNearBottom, setIsNearBottom] = useState(false)

  // only track mouse movement when the banner is visible to avoid unnecessary event listeners
  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      setIsNearBottom(e.clientY > window.innerHeight - BANNER_HEIGHT)
    }
    document.addEventListener('mousemove', onMove, { passive: true })
    return () => document.removeEventListener('mousemove', onMove)
  }, [])

  return (
    <div
      className={cn(
        'pointer-events-none flex h-12 w-full items-center justify-center border-t-2 border-main-border-error bg-main-background-subtle-semantic-danger text-center text-main-foreground-danger opacity-70 transition-transform duration-200 text-heading-xxsmall',
        isNearBottom ? 'translate-y-full' : 'translate-y-0',
      )}
    >
      {APP_BANNERS_LABELS.supportPortal}
    </div>
  )
}

export const AppBanners = () => {
  const banners = useAppBanners()
  const { payload: maintenancePayload } = useRemoteConfigPayload('maintenance-banner')

  if (banners.length === 0) return null

  return (
    <div className='pointer-events-none fixed bottom-0 z-max flex w-full flex-col'>
      {banners.map((id) => {
        if (id === 'maintenance') {
          return (
            <div
              key={id}
              className='pointer-events-auto flex h-12 w-full items-center justify-center gap-2 border-t-2 border-main-border-warning bg-main-background-subtle-semantic-warning text-center text-main-foreground-warning text-body-default'
            >
              <TriangleAlertIcon className='size-4 shrink-0' />
              <span>{maintenancePayload}</span>
            </div>
          )
        }
        return <SupportBanner key={id} />
      })}
    </div>
  )
}
